import { useMemo } from "react"
import { useQuery } from "@rocicorp/zero/react"

import { queries } from "@productlane/zero/queries"

export interface AgentMcpSection {
	id: string
	title: string
	url: string
	logoUrl?: string | null
}

// One definition of "an MCP connector the chat may be scoped to", shared by the
// selector and the sync layer. Scope is not permission: the server checks that.
export function useAgentMcpSections(): AgentMcpSection[] {
	const [sections] = useQuery(queries.sidebarSections())
	return useMemo(() => {
		if (!sections) return []
		return sections
			.filter((section) => section.type === "MCP")
			.map((section) => ({
				id: section.id,
				title: section.title,
				url: section.url,
				logoUrl: section.logoUrl ?? null,
			}))
	}, [sections])
}

export function useAgentMcpSectionIds(): string[] {
	const sections = useAgentMcpSections()
	return useMemo(() => sections.map((section) => section.id), [sections])
}
